import Typography from '@mui/material/Typography';
import {arrayOf, string} from 'prop-types';
import React, {Fragment} from 'react';
import {getNewSearchUrl} from '../utils.js';
import Link from './Link.jsx';

function PublicationDataTypes({dataTypes}) {
  if (dataTypes.length === 0) {
    return null;
  }

  return (
    <Typography sx={{marginY: 2, fontSize: '0.875rem'}} component="p">
      Data types:{' '}
      {dataTypes.map((data, i) => (
        <Fragment key={data}>
          {i > 0 ? ', ' : ''}
          <Link to={getNewSearchUrl({data})}>{data}</Link>
        </Fragment>
      ))}
    </Typography>
  );
}

PublicationDataTypes.propTypes = {
  dataTypes: arrayOf(string).isRequired,
};

export default PublicationDataTypes;
